<template>
<div :class="'form-post-wrapper' + ' ' + this.customClass">
    <span>{{ this.statusText }}</span>
    <div class="progress">
        <div class="progress-bar" role="progressbar" :aria-valuenow="this.requiredLeftPercent"
             aria-valuemin="0" aria-valuemax="100" :style="'width: ' + this.requiredLeftPercent + '%'">
        </div>
    </div>
    <button :form="this.formId" type="submit" class="btn btn-primary btn-sm-md-responsive" v-if="this.requiredCount === this.requiredFilled">{{ this.buttonText }}</button>
    <button :form="this.formId" type="submit" class="btn btn-primary btn-sm-md-responsive disabled" v-on:click="checkValue(true)" v-else>{{ this.buttonText }}</button>
</div>
</template>

<script>
export default {
    name: "form-post",
    props: ['formId','buttonText', 'leftText', 'allText', 'customClass'],

    data: function () {
        return {
            requiredCount: 0,
            requiredFilled: -1,
        }
    },

    created: function () {
        let interval = setInterval(() => this.setRequired(interval), 200);
    },

    methods: {
        setRequired: function (interval) {
            let form = document.getElementById(this.formId);
            let children = form.querySelectorAll("[required]");

            if (children.length !== 0) {
                this.requiredCount = children.length;
                let events = ['blur', 'input'];

                children.forEach(item => {
                    for (let i = 0; i < events.length; i++) {
                        item.addEventListener(events[i], event => {
                            this.checkValue();
                        })
                    }
                })

                this.checkValue();
                clearInterval(interval);
            }
        },

        checkValue: function (focus = false) {
            let form = document.getElementById(this.formId);
            let children = form.querySelectorAll("[required]");

            if (children.length !== 0) {
                this.requiredCount = children.length;
                this.requiredFilled = 0;

                children.forEach(item => {
                    item.classList.remove('focused-invalid')

                    if (item.value) {
                        this.requiredFilled++;
                    } else if (focus) {
                        item.classList.add('focused-invalid')
                    }
                })
            }
        },
    },

    computed: {
        requiredLeft: function () {
            return this.requiredCount - this.requiredFilled;
        },

        requiredLeftPercent: function () {
            return Math.round((this.requiredFilled / this.requiredCount) * 100);
        },

        statusText: function () {
            if (this.requiredCount === this.requiredFilled) {
                return this.allText;
            }

            return this.leftText + ': ' + this.requiredLeft;
        },
    }
}
</script>
